import React from "react";
import ResourcePage from "@/components/ResourcePage";
import { COUNTRIES } from "@/lib/api";

const STATUSES = ["CONFIRMED", "PROCESSING", "SHIPPED", "COMPLETED", "CANCELLED"];

export default function Orders() {
  return (
    <ResourcePage
      title="Orders" name="Order" endpoint="orders"
      subtitle="Confirmed export orders, revenue and gross profit"
      emptyMessage="No orders yet. When an accepted quotation becomes an order, it will appear here."
      canExport relations={["buyers", "products", "users"]}
      statusOptions={STATUSES}
      columns={[
        { key: "order_number", label: "Order No.", type: "mono" },
        { key: "buyer_name", label: "Buyer" },
        { key: "country", label: "Country" },
        { key: "order_value", label: "Value", type: "currency" },
        { key: "gross_margin", label: "Margin", type: "percent" },
        { key: "gross_profit", label: "Gross Profit", type: "currency" },
        { key: "status", label: "Status", type: "status" },
      ]}
      defaultValues={{ status: "CONFIRMED", currency: "INR", order_value: 0, gross_margin: 25 }}
      formFields={[
        { name: "buyer_id", label: "Buyer", type: "relation", source: "buyers", required: true },
        { name: "product_id", label: "Product", type: "relation", source: "products" },
        { name: "country", label: "Country", type: "select", options: COUNTRIES },
        { name: "quantity", label: "Quantity" },
        { name: "order_value", label: "Order value (₹)", type: "number" },
        { name: "currency", label: "Currency", type: "select", options: ["INR", "USD", "EUR", "GBP"] },
        { name: "gross_margin", label: "Gross margin (%)", type: "number" },
        { name: "assigned_to", label: "Salesperson", type: "relation", source: "users" },
        { name: "order_date", label: "Order date", type: "date" },
        { name: "status", label: "Status", type: "select", options: STATUSES },
      ]}
    />
  );
}
